export const API_URL = 'https://rpc.walletconnect.org/v1/json-rpc';
export const REOWN_TEST_EXCHANGE_ID = 'reown_test';
//# sourceMappingURL=ConstantsUtil.js.map